import { ReactComponent as CopyIcon } from "assets/CopyIcon.svg";
import { ReactComponent as DeleteIcon } from "assets/DeleteIcon.svg";
import { ReactComponent as EditIcon } from "assets/EditIcon.svg";
import { ReactComponent as Export } from "assets/Export.svg";
import { ReactComponent as PinIcon } from "assets/PinIconSmall.svg";
import { ReactComponent as UnPinIcon } from "assets/UnPinIconSmall.svg";
import {
  duplicateFilter,
  updateCorpSavedFilters,
  updateCorpSavedFiltersConsultant
} from "components/common/Filters/Filters.slice";
import { corpViewTypes } from "utils/CommonConstants";
import { editList, formFilterRequestPayload, onPostAPIDownloadFileHandler } from "utils/CommonFunctions";
import { serviceTypes } from "utils/Types";
import { downloadURLs } from "utils/URLConstants";
import { setDialog } from "../CorpUser.Slice";

export const searchInMyLists = (element: any, list: any) => {
  const listData = [];
  for (let section of list) {
    const searchedData = section?.data?.filter((e: any) => e.name?.toLowerCase()?.includes(element?.toLowerCase()));
    if (searchedData?.length) listData.push({ ...section, data: searchedData });
  }
  return listData;
};

export const getmyListType = (listType: string, listName: string) => {
  if (listType === "bookmarked") {
    return listName === "Bookmarked Plans" ? "bookmarked_plans" : "bookmarked_properties";
  }
  return listType;
};

const duplicateList = (val: any, dispatch: any, listType: string, toFilterType: string) => {
  const fromFilter = val.name === "Bookmarked Properties" ? "bookmarkedProperties" : "bookmarkedPlans";
  const fromFilterType = listType === "bookmarked" ? fromFilter : listType;
  const payload = {
    fromFilterType,
    fromFilterId: val.id ?? "0",
    toFilterType,
    name: `Copy of ${val.name}`,
    description: val.description,
    resetFilter: fromFilterType !== toFilterType
  };
  dispatch(duplicateFilter(payload));
};

const getDuplicateAsOptions = (isSmeUser: boolean, dispatch: any, listType: string) => {
  let options = [
    {
      key: "saved_property_list",
      label: "Duplicate as Saved Property List",
      enabled: true,
      icon: CopyIcon,
      action: (val: any) => duplicateList(val, dispatch, listType, "static")
    }
  ];

  if (listType === "dynamic") {
    options = [
      {
        key: "saved_filters",
        label: "Duplicate as Saved Filters",
        enabled: true,
        icon: CopyIcon,
        action: (val: any) => duplicateList(val, dispatch, listType, "dynamic")
      },
      ...options
    ];
  }

  if (isSmeUser) {
    options = [
      ...options,
      {
        key: "consultant_list",
        label: "Duplicate as Consultant List",
        enabled: true,
        icon: CopyIcon,
        action: (val: any) => duplicateList(val, dispatch, listType, "consultant")
      }
    ];
  }

  return options;
};

export const getListData = (isSmeUser: boolean, dispatch: any, savedFiltersAndLists: any) => {
  const updateMyLists = (listType: string, subList: any, updatedVal: {}) => {
    if (listType === "consultant") {
      const payloadData = { ...updatedVal };
      dispatch(updateCorpSavedFiltersConsultant({ payload: payloadData, listId: subList?.id }));
    } else {
      let payload: { [key: string]: any } = {};
      payload[listType] = [{ ...subList, ...updatedVal }];
      dispatch(updateCorpSavedFilters(payload));
    }
  };
  const downloadURL = downloadURLs.exportCorpProperties;
  const pinUnPinMenus = (listType: string) => {
    return [
      {
        label: "Pin to top",
        icon: PinIcon,
        enabled: true,
        action: (val: any) => updateMyLists(listType, val, { isFlagged: val?.isFlagged === "Y" ? "N" : "Y" })
      },
      {
        label: "Unpin from top",
        icon: UnPinIcon,
        enabled: true,
        action: (val: any) => updateMyLists(listType, val, { isFlagged: val?.isFlagged === "Y" ? "N" : "Y" })
      }
    ];
  };
  return [
    {
      label: "Bookmarked",
      id: 0,
      listType: "bookmarked",
      data: savedFiltersAndLists?.["bookmarked"],
      menu: [
        {
          label: "Export",
          icon: Export,
          enabled: true,
          action: (val: any) => {
            const data = {
              view: corpViewTypes.myList,
              myListType: getmyListType("bookmarked", val.name),
              myListId: val.id
            };
            onPostAPIDownloadFileHandler(downloadURL, serviceTypes.userplan, data);
          }
        },
        {
          label: "Duplicate",
          icon: CopyIcon,
          enabled: true,
          subMenu: getDuplicateAsOptions(isSmeUser, dispatch, "bookmarked")
        }
      ]
    },
    {
      label: "Saved Filters",
      id: 1,
      listType: "dynamic",
      data: savedFiltersAndLists?.["dynamic"],
      menu: [
        {
          label: "Rename",
          icon: EditIcon,
          enabled: true,
          action: (val: any) => dispatch(setDialog({ dialogName: "renameList", isOpen: true, data: val }))
        },
        {
          label: "Export",
          icon: Export,
          enabled: true,
          action: (val: any) => {
            const data = {
              ...formFilterRequestPayload(val.filters),
              view: corpViewTypes.myList,
              myListType: "dynamic",
              myListId: val.id
            };
            onPostAPIDownloadFileHandler(downloadURL, serviceTypes.userplan, data);
          }
        },
        {
          label: "Duplicate",
          icon: CopyIcon,
          enabled: true,
          subMenu: getDuplicateAsOptions(isSmeUser, dispatch, "dynamic")
        },
        {
          label: "Delete",
          icon: DeleteIcon,
          enabled: true,
          action: (val: any) =>
            dispatch(setDialog({ dialogName: "deleteList", isOpen: true, data: val, listType: "dynamic" }))
        },
        ...pinUnPinMenus("dynamic")
      ]
    },
    {
      label: "Saved Property Lists",
      id: 2,
      listType: "static",
      data: savedFiltersAndLists?.["static"],
      menu: [
        {
          label: "Edit",
          icon: EditIcon,
          enabled: true,
          action: (val: any) => editList(val, "static")
        },
        {
          label: "Export",
          icon: Export,
          enabled: true,
          action: (val: any) => {
            const data = {
              view: corpViewTypes.myList,
              myListType: "static",
              myListId: val.id
            };
            onPostAPIDownloadFileHandler(downloadURL, serviceTypes.userplan, data);
          }
        },
        {
          label: "Duplicate",
          icon: CopyIcon,
          enabled: true,
          subMenu: getDuplicateAsOptions(isSmeUser, dispatch, "static")
        },
        {
          label: "Delete",
          icon: DeleteIcon,
          enabled: true,
          action: (val: any) =>
            dispatch(setDialog({ dialogName: "deleteList", isOpen: true, data: val, listType: "static" }))
        },
        ...pinUnPinMenus("static")
      ]
    },
    {
      label: "Consultant Lists",
      id: 3,
      listType: "consultant",
      data: savedFiltersAndLists?.["consultant"],
      menu: [
        { label: "Edit", icon: EditIcon, enabled: true, action: (val: any) => editList(val, "sc") },
        {
          label: "Export",
          icon: Export,
          enabled: true,
          action: (val: any) => {
            const data = {
              view: corpViewTypes.myList,
              myListType: "consultant",
              myListId: val.id
            };
            onPostAPIDownloadFileHandler(downloadURL, serviceTypes.userplan, data);
          }
        },
        {
          label: "Duplicate",
          icon: CopyIcon,
          enabled: true,
          subMenu: getDuplicateAsOptions(isSmeUser, dispatch, "consultant")
        },
        {
          label: "Delete",
          icon: DeleteIcon,
          enabled: true,
          action: (val: any) => dispatch(setDialog({ dialogName: "deleteSCList", isOpen: true, data: val }))
        },
        ...pinUnPinMenus("consultant")
      ]
    }
  ];
};

export const getAllBreakupLists = (statusBreakUp: any, showNotStarted: boolean = false) => {
  if (statusBreakUp) {
    let list = [
      { name: "New", value: statusBreakUp?.["New"], isShowStar: statusBreakUp["newOverDue"] > 0 },
      {
        name: "In Progress",
        value: statusBreakUp?.["In Progress"],
        isShowStar: statusBreakUp?.["inProgressOverDue"] > 0
      },
      { name: "Completed", value: statusBreakUp["Completed"], isShowStar: false }
    ];
    if (showNotStarted) {
      // list = [...list, { name: "Not Started", value: statusBreakUp["Not Started"], isShowStar: false }];
      list.unshift({ name: "Not Started", value: statusBreakUp["Not Started"], isShowStar: false });
    }
    return list;
  }
  return null;
};
